var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"h-64 flex items-center justify-center"},[_c('fa',{attrs:{"icon":['fal', 'spinner-third'],"size":"10x","spin":""}})],1):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }